// extracted by mini-css-extract-plugin
module.exports = {"headline":"styles_headline__PlLy6","label":"styles_label__S03Ke","caption":"styles_caption__HoVN5","description":"styles_description__QwQUR","content":"styles_content__23Y5o"};